<template>
  <div class="flex h-full flex-col sm:flex-row">
    <!-- Mobile: the work menu opens in a drawer -->
    <div
      class="flex shrink-0 items-center gap-3 border-b px-4 py-2 sm:hidden print:hidden"
    >
      <button
        type="button"
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border bg-white active:scale-95 dark:bg-slate-700 dark:text-gray-300"
        @click="mobileMenuOpen = true"
      >
        <FontAwesomeIcon :icon="['fal', 'bars']" size="lg" />
      </button>
      <span class="min-w-0 flex-1 truncate font-medium">{{ work?.title }}</span>
    </div>
    <TransitionRoot :show="mobileMenuOpen" as="template">
      <Dialog
        as="div"
        class="relative z-100 sm:hidden"
        @close="mobileMenuOpen = false"
      >
        <TransitionChild
          as="template"
          enter="duration-200 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-150 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-black/30" />
        </TransitionChild>
        <TransitionChild
          as="template"
          enter="duration-200 ease-out"
          enter-from="-translate-x-full"
          enter-to="translate-x-0"
          leave="duration-150 ease-in"
          leave-from="translate-x-0"
          leave-to="-translate-x-full"
        >
          <DialogPanel
            class="fixed inset-y-0 left-0 flex w-80 max-w-[85vw] flex-col p-3"
          >
            <TheWorkNav />
          </DialogPanel>
        </TransitionChild>
      </Dialog>
    </TransitionRoot>

    <!-- Desktop: fixed-width menu, as Funeral Manager's dossier menu -->
    <div class="hidden w-72 shrink-0 sm:block print:hidden">
      <div class="flex h-full max-h-full flex-col gap-y-2 overflow-y-auto pb-1">
        <TheWorkNav class="mb-2 shrink-0" />
        <WorkPreviewEvent
          v-for="(event, index) in events"
          :key="index"
          :event="event"
          class="shrink-0"
        />
      </div>
    </div>

    <div class="flex min-h-0 min-w-0 flex-1 flex-col gap-y-3">
      <div class="h-full max-h-full">
        <div class="@container/dossier-main h-full max-h-full sm:-mr-5">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'
import TheWorkNav from '@p/works/form/sideBar/nav/TheWorkNav.vue'
import WorkPreviewEvent from '@p/works/form/sideBar/events/WorkPreviewEvent.vue'

/**
 * Frame of the work ("dossier") form, after Funeral Manager's
 * TheDossierFormEditPage: the work menu on the left (a drawer on mobile),
 * the current tab on the right in the `dossier-main` container that
 * PageSection's container queries target.
 */
export default {
  name: 'TheWorkFormShell',
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
    FontAwesomeIcon,
    TheWorkNav,
    WorkPreviewEvent
  },
  props: {
    events: { type: Array, required: false, default: () => [] }
  },
  data() {
    return { mobileMenuOpen: false }
  },
  computed: {
    ...mapGetters({ work: 'work/getWork' })
  },
  watch: {
    '$route.fullPath'() {
      this.mobileMenuOpen = false
    }
  }
}
</script>
